import * as types from './PromotionsTypes';

export default function PromotionsReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_PROMOTIONS:
            return {
                ...state,
                getPromotions: {
                    ...state.getPromotions,
                    promotions: payload.data,
                    firstPromotion: payload.first,
                    lastPromotion: payload.last,
                    nextPromotions: payload.next,
                    promotionsFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_PROMOTIONS_LOADING:
            return {
                ...state,
                getPromotions: {
                    ...state.getPromotions,
                    loading: true
                },
            };
        case types.GET_PROMOTIONS_ERROR:
            return {
                ...state,
                getPromotions: {
                    ...state.getPromotions,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PROMOTIONS_ALL_MONTH:
            return {
                ...state,
                getPromotionsAllMonth: {
                    ...state.getPromotionsAllMonth,
                    promotions: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_PROMOTIONS_ALL_MONTH_LOADING:
            return {
                ...state,
                getPromotionsAllMonth: {
                    ...state.getPromotionsAllMonth,
                    loading: true
                },
            };
        case types.GET_PROMOTIONS_ALL_MONTH_ERROR:
            return {
                ...state,
                getPromotionsAllMonth: {
                    ...state.getPromotionsAllMonth,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PROMOTIONS_FILTER:
            return {
                ...state,
                getPromotions: {
                    ...state.getPromotions,
                    promotionsFilter: payload.data,
                    firstPromotion: payload.first,
                    lastPromotion: payload.last,
                    nextPromotions: payload.next,
                    loading: false
                },
            };
        case types.GET_PROMOTIONS_FILTER_LOADING:
            return {
                ...state,
                getPromotions: {
                    ...state.getPromotions,
                    loading: true
                },
            };
        case types.GET_PROMOTIONS_FILTER_ERROR:
            return {
                ...state,
                getPromotions: {
                    ...state.getPromotions,
                    promotionsFilter: [],
                    loading: false
                },
            };
        case types.GET_PROMOTIONS_EXCEL:
            return {
                ...state,
                getPromotionsExcel: {
                    ...state.getPromotionsExcel,
                    promotions: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_PROMOTIONS_EXCEL_LOADING:
            return {
                ...state,
                getPromotionsExcel: {
                    ...state.getPromotionsExcel,
                    loading: true
                },
            };
        case types.GET_PROMOTIONS_EXCEL_ERROR:
            return {
                ...state,
                getPromotionsExcel: {
                    ...state.getPromotionsExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PROMOTIONS_FILTER_EXCEL:
            return {
                ...state,
                getPromotionsExcel: {
                    ...state.getPromotionsExcel,
                    promotionsFilter: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_PROMOTIONS_FILTER_EXCEL_LOADING:
            return {
                ...state,
                getPromotionsExcel: {
                    ...state.getPromotionsExcel,
                    loading: true
                },
            };
        case types.GET_PROMOTIONS_FILTER_EXCEL_ERROR:
            return {
                ...state,
                getPromotionsExcel: {
                    ...state.getPromotionsExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.PROMOTIONS_EXCEL_RESET_STATE:
            return {
                ...state,
                getPromotionsExcel: {
                    ...state.getPromotionsExcel,
                    promotions: [],
                    promotionsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_PROMOTIONS:
            return {
                ...state,
                createPromotions: {
                    ...state.createPromotions,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_PROMOTIONS_LOADING:
            return {
                ...state,
                createPromotions: {
                    ...state.createPromotions,
                    loading: true
                },
            };
        case types.CREATE_PROMOTIONS_ERROR:
            return {
                ...state,
                createPromotions: {
                    ...state.createPromotions,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PROMOTIONS_BY_ID:
            return {
                ...state,
                getPromotionsById: {
                    ...state.getPromotionsById,
                    promotion: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PROMOTIONS_BY_ID_LOADING:
            return {
                ...state,
                getPromotionsById: {
                    ...state.getPromotionsById,
                    loading: true,
                },
            };
        case types.GET_PROMOTIONS_BY_ID_ERROR:
            return {
                ...state,
                getPromotionsById: {
                    ...state.getPromotionsById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.UPDATE_PROMOTIONS_BY_ID:
            return {
                ...state,
                updatePromotionsById: {
                    ...state.updatePromotionsById,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getPromotionsById: {
                    ...state.getPromotionsById,
                    promotion: {
                        ...state.getPromotionsById.promotion,
                        isApproved: payload.newIsApproved,
                        status: payload.newStatus,
                        usuarioAtendio: payload.newUserAttends,
                        comentario: payload.newCommentary
                    },
                },
            };
        case types.UPDATE_PROMOTIONS_BY_ID_LOADING:
            return {
                ...state,
                updatePromotionsById: {
                    ...state.updatePromotionsById,
                    loading: true
                },
            };
        case types.UPDATE_PROMOTIONS_BY_ID_ERROR:
            return {
                ...state,
                updatePromotionsById: {
                    ...state.updatePromotionsById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_PROMOTIONS_RESET_STATE:
            return {
                ...state,
                updatePromotionsById: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            }
        case types.VERIFY_PROMOTION_BY_ID:
            return {
                ...state,
                verifyPromotion: {
                    ...state.verifyPromotion,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.VERIFY_PROMOTION_BY_ID_LOADING:
            return {
                ...state,
                verifyPromotion: {
                    ...state.verifyPromotion,
                    loading: true
                },
            };
        case types.VERIFY_PROMOTION_BY_ID_ERROR:
            return {
                ...state,
                verifyPromotion: {
                    ...state.verifyPromotion,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.VERIFY_PROMOTION_BY_ID_RESET_STATE:
            return {
                ...state,
                verifyPromotion: {
                    ...state.verifyPromotion,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.PROMOTIONS_RESET_STATE:
            return {
                getPromotions: {
                    promotions: [],
                    firstPromotion: null,
                    lastPromotion: null,
                    nextPromotions: null,
                    promotionsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getPromotionsById: {
                    promotion: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                updatePromotionsById: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                verifyPromotion: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getPromotionsExcel: {
                    promotions: [],
                    promotionsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            };
    
        default:
            return state;
    }
}